import React, { useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min';
import Loading from 'react-loading';
import { updateUserInformation } from '../../util/AuthUtils';
import LocalizationContext from '../../context/LocalizationContext';
/**
 * Creates modal that allows user to modify their preferred language and timezone
 * @param props - props to render modal correctly
 */

const BasicUserConfigModal = _ref => {
  let {
    show,
    onHide,
    title,
    userInfo,
    refresh
  } = _ref;
  const [responseError, setResponseError] = useState('');
  const [locale, setLocale] = useState(userInfo.userSettings.baseSettings.locale || 'en-US');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [timezone, setTimezone] = useState(userInfo.userSettings.baseSettings.timezone || 'America/Los_Angeles');
  const localizedStrings = useContext(LocalizationContext);
  const onSubmit = async e => {
    e.preventDefault();
    try {
      const newUserConfig = {
        locale,
        timezone
      };
      await updateUserInformation(newUserConfig.locale, newUserConfig.timezone);
      onHide();
      if (refresh) {
        refresh();
      }
      window.location.reload();
    } catch (error) {
      setResponseError('');
      setIsSubmitting(false);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, null, title)), /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    className: "form-horizontal",
    "data-testid": "modal-form"
  }, /*#__PURE__*/React.createElement(Modal.Body, null, responseError ?? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger"
  }, responseError), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "locale",
    className: "col-form-label col-2"
  }, "Locale"), /*#__PURE__*/React.createElement("div", {
    className: "col-10"
  }, /*#__PURE__*/React.createElement("select", {
    id: "locale",
    className: "form-control",
    "data-testid": "locale-field",
    value: locale,
    onChange: e => {
      setLocale(e.target.value);
    }
  }, [{
    id: 'en-US',
    name: 'English'
  }, {
    id: 'ja',
    name: '日本語'
  }].map(option => /*#__PURE__*/React.createElement("option", {
    value: option.id
  }, option.name))))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "timezone",
    className: "col-2 col-form-label"
  }, "Timezone"), /*#__PURE__*/React.createElement("div", {
    className: "col-10"
  }, /*#__PURE__*/React.createElement("select", {
    id: "timezone",
    className: "form-control",
    "data-testid": "timezone-field",
    value: timezone,
    onChange: e => {
      setTimezone(e.target.value);
    }
  }, moment.tz.names().map(zone => /*#__PURE__*/React.createElement("option", {
    value: zone
  }, zone)))))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onHide,
    "data-testid": "close-btn"
  }, localizedStrings.hyrule.general.close), /*#__PURE__*/React.createElement(Button, {
    "data-testId": "submit-button",
    type: "submit"
  }, isSubmitting ? /*#__PURE__*/React.createElement(Loading, {
    type: "spin",
    height: 20,
    width: 20
  }) : localizedStrings.hyrule.general.update))));
};
export default BasicUserConfigModal;